import * as types from "../types/types";

export const ArtWorkTabValuesAction = (data) => ({
  payload: data,
  type: types.UPDATE_ARTWORK_TAB_VALUES,
});
